
import { regionState, regionModal } from '@/utils/regionModal'
import { REGIONS, REGION_PATTERNS } from '@/utils/regions'

export default {
  name: 'AppRegion',

  data() {
    return {
      detectedRegionCode: 'tshk',
      regions: REGIONS,
      isGeocoding: false
    }
  },

  computed: {
    sortedRegions() {
      if (!this.regions || typeof this.regions !== 'object') return {}

      const entries = Object.entries(this.regions)
      if (entries.length === 0) return {}

      const [firstEntry, ...restEntries] = entries

      restEntries.sort(([_, keyA], [__, keyB]) => {
        const labelA = this.$t(keyA)
        const labelB = this.$t(keyB)
        return labelA.localeCompare(labelB, ['uz', 'ru', 'en'], { sensitivity: 'base' })
      })

      return Object.fromEntries([firstEntry, ...restEntries])
    },
    isVisible: {
      get() {
        return regionState.isOpen
      },
      set(val) {
        if (!val) regionModal.close()
      }
    },
    step: {
      get() {
        return regionState.step
      },
      set(val) {
        regionState.step = val
      }
    },
    currentRegionKey() {
      return this.regions[this.detectedRegionCode] || this.regions.tshk
    }
  },

  watch: {
    isVisible(isOpen) {
      if (typeof document !== 'undefined') {
        if (isOpen) {
          document.documentElement.classList.add('fixed')
        } else {
          document.documentElement.classList.remove('fixed')
        }
      }
    }
  },

  mounted() {
    const savedRegion = this.$cookies.get('user_region', { parseJSON: false })

    if (savedRegion) {
        regionState.currentRegion = savedRegion 
        return
    }

    this.setRegionCookie('tshk')
    regionModal.open(1)
    this.detectUserRegion()
  },

  methods: {
    closeModal() {
      this.confirmRegion(this.detectedRegionCode)
    },
    
    setRegionCookie(code) {
      this.$cookies.set('user_region', code, {
        path: '/',
        maxAge: 60 * 60 * 24 * 30,
        secure: true,
        httpOnly: false,
        sameSite: 'lax'
      })
      regionState.currentRegion = code
    },

    confirmRegion(code) {
      this.setRegionCookie(code)
      regionModal.close()
      this.$nuxt.refresh()
    },

    detectUserRegion() {
      if (!navigator.geolocation) {
        this.detectedRegionCode = 'tshk'
        return
      }

      this.isGeocoding = true

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude
          const lng = position.coords.longitude
          this.geocodePosition(lat, lng)
        },
        (error) => {
          console.warn('Geolocation error:', error.message)
          this.detectedRegionCode = 'tshk'
          this.isGeocoding = false
        },
        { timeout: 10000, maximumAge: 60000 }
      )
    },

    async geocodePosition(lat, lng) {
      try {
        const maps = await this.loadGoogleMapsScript()

        if (!maps) {
          this.detectedRegionCode = 'tshk'
          return
        }

        const geocoder = new maps.Geocoder()
        const latlng = { lat, lng }

        geocoder.geocode({ location: latlng, language: 'uz' }, (results, status) => {
          console.log(results, status)
          if (status === 'OK' && results[0]) {
            this.matchRegionFromGoogle(results[0])
          } else {
            this.detectedRegionCode = 'tshk'
          }
          this.isGeocoding = false
        })
      } catch (e) {
        console.warn('Geocoding error:', e)
        this.detectedRegionCode = 'tshk'
        this.isGeocoding = false
      }
    },

    loadGoogleMapsScript() {
      return new Promise((resolve) => {
        if (window.google && window.google.maps) {
          return resolve(window.google.maps)
        }

        const existingScript = document.getElementById('google-maps-sdk')
        if (existingScript) {
          const interval = setInterval(() => {
            if (window.google && window.google.maps) {
              clearInterval(interval)
              resolve(window.google.maps)
            }
          }, 100)
          return
        }

        const apiKey = process.env.GOOGLE_MAP_API_KEY || 'AIzaSyBshU76IO157O-dUqCErHnDbsVMa8YGF1E'
        const script = document.createElement('script')
        script.id = 'google-maps-sdk'
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places,geometry`
        script.async = true
        script.defer = true

        script.onload = () => {
          if (window.google && window.google.maps) {
            resolve(window.google.maps)
          } else {
            resolve(null)
          }
        }

        script.onerror = () => {
          resolve(null)
        }

        document.head.appendChild(script)
      })
    },

    matchRegionFromGoogle(geoResult) {
      const addressComponents = geoResult.address_components || []
      
      const fullAddressText = addressComponents
        .map(comp => `${comp.long_name || ''} ${comp.short_name || ''}`.toLowerCase())
        .join(' ')

      for (const item of REGION_PATTERNS) {
        if (item.keywords.some(keyword => fullAddressText.includes(keyword))) {
          this.detectedRegionCode = item.code
          return
        }
      }

      this.detectedRegionCode = 'tshk'
    }
  }
}
